import routerOptions0 from "/home/zedplan/www/divas-web-ssr/app/router.options.ts";
import routerOptions1 from "/home/zedplan/www/divas-web-ssr/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}